import './Footer.css';

const Footer = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de paineis de LED para meu evento.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>ACJ Locações</h3>
          <p>Soluções profissionais em painéis de LED para eventos corporativos, shows e festas.</p>
        </div>
        
        <div className="footer-section">
          <h4>Links Rápidos</h4>
          <ul>
            <li><a href="#hero-info">Sobre</a></li>
            <li><a href="#service-types">Serviços</a></li>
            <li><a href="#portfolio">Portfólio</a></li>
            <li><a href="#contato">Contato</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contato</h4>
          <ul>
            <li>
              <button 
                onClick={handleWhatsAppClick}
                className="footer-link"
                style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0 }}
              >
                <i className="fas fa-mobile-alt"></i>
                <span>(31) 97203-5157</span>
              </button>
            </li>
            <li>
              <a href="mailto:contato@acjlocacoes.com.br">
                <i className="fas fa-envelope"></i>
                <span>contato@acjlocacoes.com.br</span>
              </a>
            </li>
            <li>
              <span>
                <i className="fas fa-map-marker-alt"></i>
                <span>Belo Horizonte, MG</span>
              </span>
            </li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Redes Sociais</h4>
          <div className="social-links">
            <a 
              href="https://www.instagram.com/acjlocacoes/" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a 
              href="#" 
              onClick={(e) => {
                e.preventDefault();
                handleWhatsAppClick();
              }}
              aria-label="WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 ACJ Locações - Todos os direitos reservados</p>
      </div>
    </footer>
  );
};

export default Footer; 
